import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  QueryProvider
} from '@thd-nucleus/data-sources';
import { HotspotDrawer } from './HotspotDrawer';

const HotspotDrawerContainer = ({ componentId, style, headline, drawerData }) => {
  const [legalDrawerOpen, setLegalDrawerOpen] = useState(false);

  const setDrawerOpen = (isOpen) => {
    setLegalDrawerOpen(isOpen);
  };
  return (
    <>
      <QueryProvider cacheKey="HotspotDrawerContainer">
        <HotspotDrawer
          componentId={componentId}
          headline={headline}
          isOpen={legalDrawerOpen}
          setIsOpen={setDrawerOpen}
          drawerData={drawerData}
        />
      </QueryProvider>
      <div
        className="sui-absolute"
        data-testid="hotspot-drawer-block"
        style={style}
      >
        <button
          type="button"
          onClick={() => setLegalDrawerOpen(true)}
          aria-label={`Open drawer for ${headline}`}
          className="sui-block sui-cursor-pointer sui-h-full sui-w-full"
        />
      </div>
    </>
  );
};

HotspotDrawerContainer.propTypes = {
  componentId: PropTypes.string,
  style: PropTypes.shape({
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    left: PropTypes.string.isRequired,
    top: PropTypes.string.isRequired,
  }).isRequired,
  headline: PropTypes.string.isRequired,
  drawerData: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
  }))
};

HotspotDrawerContainer.defaultProps = {
  componentId: undefined,
  drawerData: undefined
};

export { HotspotDrawerContainer };